import { PuzzleUpdate } from '../types';

import axiosInstance from './axiosInstance';

export async function updatePuzzle(puzzleUuid: string, update: PuzzleUpdate) {
  await axiosInstance.put(`/puzzles/${puzzleUuid}`, update);
}
